var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
  'style-round': _vm.cornerStyle === 'round',
  'style-square': _vm.cornerStyle === 'square',
  fontLoaded: _vm.fontLoaded
}},[(!(!_vm.isVoteable || _vm.votingComplete || !_vm.votingEnabled || (_vm.pollType === 'poll' && !_vm.selectedOptions.length) || _vm.next))?_c('button',{class:{ multivote: _vm.showMultiVote },style:({ fontFamily: _vm.fontFamilyCSS }),attrs:{"id":"btn-multivote"},on:{"click":function($event){return _vm.submit($event)}}},[_vm._v(" "+_vm._s(_vm.submitButtonText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }